import React, { useEffect } from "react";
import {
  Button,
  InputAdornment,
  LinearProgress,
  TextField,
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import {
  buyTicket,
  getTicketInvoice,
} from "../../../../SearchPage/_redux/searchCrud";
import Countdown from "react-countdown";
import { Dialog, DialogTitle, Slide, Tabs, Tab } from "@material-ui/core";
import {
  login,
  loginWithMobile,
  SignInWithMobile,
  VerifyLogin,
  VerifyRegister,
} from "./cruds";
import { Formik } from "formik";
import { actions } from "../../../../SearchPage/_redux/searchRedux";
import { actions as authActions } from "../../../../Auth/_redux/authRedux";
import ReactLoading from "react-loading";
import ReactCodeInput from "react-code-input";
import { useMediaQuery } from "react-responsive";
import { makeStyles } from "@material-ui/styles";
import AuthModal from "../../../../RUComponent/AuthModal";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Confirmation = (props) => {
  const propsz = {
    className: "class-Input",
    inputStyle: {
      textAlign: "center",
      fontFamily: "sans",
      borderRadius: "6px",
      border: "1px solid lightgrey",
      boxShadow: "rgb(0 0 0 / 10%) 0px 0px 10px 0px",
      margin: "4px",
      paddingLeft: "8px",
      paddingRight: "0px",
      width: "10%",
      height: "42px",
      fontSize: "32px",
      boxSizing: "border-box",
      color: "black",
      backgroundColor: "white",
      direction: "ltr",
      flexGrow: 1,
    },
    touch: {
      border: "1px solid green",
    },
    inputStyleInvalid: {
      fontFamily: "monospace",
      margin: "4px",
      MozAppearance: "textfield",
      width: "15px",
      borderRadius: "3px",
      fontSize: "14px",
      height: "26px",
      paddingLeft: "7px",
      // backgroundColor: "red",
      // color: "red",
      // border: "1px solid red",
    },
  };

  const { state } = useSelector((state) => ({
    state: state.search,
  }));

  let { state: authState } = useSelector((state) => ({
    state: state.auth,
  }));

  // let { state: phonNumber } = useSelector((state) => ({
  //   state: state.phonNumber,
  // }));

  const [open, setOpen] = React.useState(false);
  const [value, setValue] = React.useState("login");
  const [verifyTime, setVerifyTime] = React.useState(false);
  const [isLoading2, setIsLoading2] = React.useState(false);
  const [errMessage, setErrMessage] = React.useState(null);
  const [codeErrMessage, setCodeErrMessage] = React.useState(null);
  const [ticketErr, setTicketErr] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const [isLoginLoading, setIsLoginLoading] = React.useState(false);
  const [isPinLoading, setIsPinLoading] = React.useState(false);
  const [counterRemained, setCounterRemained] = React.useState(120000);
  const [isTotalValid, setIsTotalValid] = React.useState(false);

  const useStyles = makeStyles({
    barColorPrimary: {
      background: "red",
    },
  });

  const classes = useStyles();

  const counterRenderer = ({ total }) => {
    setCounterRemained(total);
    const mainMin = 120000;
    const onePercent = mainMin / 100;
    const leftedPercent = Math.floor(total / onePercent);

    return (
      <LinearProgress
        variant="determinate"
        value={leftedPercent}
        dir="ltr"
        style={{ height: "0.7rem", borderRadius: "10px" }}
        className={` w-100 mx-auto`}
      />
    );
  };

  const isMobile = useMediaQuery({ query: `(max-width: 760px)` });

  const dispatch = useDispatch();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setIsLoading(false);
    setVerifyTime(false);
    setOpen(false);
  };

  const history = useHistory();
  const passengersCount = history.location.pathname.split("/")[6].split(",");
  const splittedURL = history.location.pathname.split("/");

  const buyTicketHandler = (res) => {
    const srcId = +window.localStorage.getItem("srcId");
    const destId = +window.localStorage.getItem("destId");

    const buyTicketData = {
      destTownshipId: destId,
      sourceTownshipId: srcId,
      travelId: +splittedURL[5],
      listOfPassengers: state.fullSeats,
    };

    buyTicket(buyTicketData, res.data.data.token).then((res) => {

      const params = {
        ticketId: res.data.ticketId,
        platform: 0,
      };
      saveToLocal(res.data.ticketId); // save to localStorage to avoid overwriting
      getTicketInvoice(params, res.data.data.token).then((res) => {
        res.data["ticketId"] = params.ticketId;
        dispatch(actions.setTicketInvoice(res.data));
      });
      props.handleComplete();
    });
  };

  const saveToLocal = (ticketId) => {
    const reserve_keys = {
      key: history.location.key + props.step,
      userId: authState.user.id,
      seat: state.fullSeats,
      ticketId: ticketId,
      expiry: Date.now(),
    }
    var key_refresh = JSON.parse(localStorage.getItem('reserve-refresh'));
    if (!key_refresh) {
      console.log("local created")
      localStorage.setItem('reserve-refresh', JSON.stringify(reserve_keys));
    } else {
      localStorage.removeItem("reserve-refresh")
      localStorage.setItem('reserve-refresh', JSON.stringify(reserve_keys));
    }
  }

  // useEffect(() => {
  //   const current_key = history.location.key + props.step
  //   var now = Date.now();
  //   var key_refresh = JSON.parse(localStorage.getItem('reserve-refresh'));
  //   if (key_refresh) {
  //     const timeup = now - key_refresh.expiry > 10 * 60 * 1000 // 10 minutes
  //     console.log("timeup", now, key_refresh.expiry, now - key_refresh.expiry, timeup)
  //     if (timeup) {
  //       localStorage.removeItem("reserve-refresh")
  //     } else {
  //       var alert = window.confirm("شما قبلا رزرو کرده اید. آیا میخواهید ادامه دهید یا کنسل میکنید؟")
  //       if (alert === true) {
  //         // continue with previous request
  //         console.log("continue with previous request")
  //       } else {
  //         // reject 
  //         localStorage.removeItem("reserve-refresh")
  //         console.log("reject")
  //       }
  //     }
  //   }
  // }, [])

  return (
    <div style={{ marginBlock: "4rem 2rem" }}>
      <div
        className="d-block d-md-flex bg-white py-3 container"
        style={{ border: "1px solid darkgray", borderRadius: 13 }}
      >
        <div className="col-md-8 d-none d-md-block mt-3">
          <ul>
            <li style={{ fontSize: 15 }} className="my-3">
              برای دریافت مشخصات بلیط و مشاهده پیش فاکتور بر روی دکمه{" "}
              <b>تایید و ادامه</b> کلیک کنید.
            </li>
            <li style={{ fontSize: 15 }} className="my-3">
              تایید و ادامه فرآیند خرید بلیط از سایت ایباس، به معنای پذیرش 
              <a link="https://ebus.ir/Conditions"> <b>مقررات ایباس و قوانین حمل و نقل جاده ای</b> </a>
               می باشد.
            </li>
            <li style={{ fontSize: 15 }} className="my-3">
              مدت زمان رزرو بلیط برای شما 15 دقیقه می باشد. لطفا پیش از سپری شدن، خرید خود را نهایی کنید.
            </li>
          </ul>
        </div>
        <div
          className={`col-sm-12 col-md-4 ${!isMobile &&
            "border-left"} border-secondary`}
        >
          <h5
            className="d-flex justify-content-between my-2"
            style={{ opacity: "0.55" }}
          >
            <span>بلیط({+passengersCount[0] + +passengersCount[1]} نفر)</span>
            <span>{state.totalPrice.toLocaleString('ar-EG')} ریال</span>
          </h5>
          <div className="line w-100 mx-auto"></div>
          <h5
            className="d-flex justify-content-between my-2"
            style={{ color: "#6dd06d" }}
          >
            <span>جمع کل</span>
            <h3>
              <b>{state.totalPrice.toLocaleString('ar-EG')} ریال</b>
            </h3>
          </h5>
          {props.isTotalValid && state.adult + state.child === 0 ? (
            <Button
              onClick={() => {
                setIsLoading(true);
                const srcId = +window.localStorage.getItem("srcId");
                const destId = +window.localStorage.getItem("destId");
                const orderIDz = localStorage.getItem("orderID");
                const phone = state.phoneNumber.phoneNumber[0] == 0 ? state.phoneNumber.phoneNumber : `0${state.phoneNumber.phoneNumber}`;
                const passenger = state.phoneNumber.passenger
                const data = {
                  destTownshipId: destId,
                  sourceTownshipId: srcId,
                  travelId: +splittedURL[5],
                  listOfPassengers: state.fullSeats,
                  travelTicketId: +splittedURL[2],
                  otherSupervisor: state.phoneNumber.phoneNumber ? { phone, passenger } : null,
                  orderId: orderIDz,
                };
                console.log("dateeeeee", data)
                if (authState.user) {
                  buyTicket(data, authState.user.token)
                    .then((res) => {
                      const params = {
                        ticketId: res.data.ticketId,
                        platform: 0,
                      };
                      saveToLocal(res.data.ticketId); // save to localStorage to avoid overwriting
                      setTicketErr(null);
                      setIsLoading(false);
                      getTicketInvoice(params, authState.user.token)
                        .then((res) => {
                          res.data["ticketId"] = params.ticketId;
                          dispatch(actions.setTicketInvoice(res.data));
                          setTicketErr(null);

                          props.handleComplete();
                        })
                        .catch((err) => {
                          setTicketErr("مشکلی در ارتباط با سرور بوجود آمد");
                        });
                    })
                    .catch((err) => {
                      setIsLoading(false);
                      if (
                        err.response.data.message ===
                        "Selected seats are not available!"
                      ) {
                        setTicketErr("صندلی مورد نظر رزرو شده است");
                      } else if (+err.response.data.status === 401) {
                        handleClickOpen();
                      } else {
                        setTicketErr("مشکلی در ارتباط با سرور بوجود آمد");
                      }
                    });
                } else {
                  handleClickOpen();
                }
              }}
              className="btn  w-100 d-flex align-items-center justify-content-center text-white"
              style={{
                borderRadius: "13px",
                backgroundColor: "#6dd06d",
                height: "4rem",
              }}
            >
              <h6 className="my-auto text-white">
                {isLoading ? (
                  <ReactLoading
                    type={"spin"}
                    color={"white"}
                    height={"100%"}
                    width={"2.5rem"}
                  />
                ) : (
                  <b>تایید و ادامه</b>
                )}
              </h6>
            </Button>
          ) : (
            <Button
              // onClick={() => props.handleComplete()}
              className="btn  w-100  d-flex align-items-center justify-content-center text-white"
              disabled
              style={{
                borderRadius: "13px",
                height: "4rem",
                backgroundColor: "#6dd06d",
              }}
            >
              <h6 className="my-auto text-white">
                <b>تایید و ادامه</b>
              </h6>
            </Button>
          )}
          <h5 className="mt-5 d-flex" style={{ color: "red" }}>
            <i
              className={`fa fa-exclamation-circle ${ticketErr ? "d-block" : "d-none"
                }`}
              style={{ color: "red", marginInline: "10px" }}
            ></i>
            {ticketErr}
          </h5>
        </div>
      </div>
      <AuthModal
        modal={"login"}
        open={open}
        handleClose={handleClose}
        buyTicketHandler={buyTicketHandler}
      />
    </div>
  );
};

export default Confirmation;
